import { render } from "./reviewers.vue?vue&type=template&id=6fb47398&scoped=true"
import script from "./reviewers.vue?vue&type=script&lang=js"
export * from "./reviewers.vue?vue&type=script&lang=js"

import "./reviewers.vue?vue&type=style&index=0&id=6fb47398&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb47398"]])

export default __exports__